/**
 * /settings index — redirects to the first sub-page so the gear-icon
 * link doesn't land users on an empty Outlet shell.
 *
 * Tags is always available to Manager+ (the role required to see the
 * shell at all) so it's the safe default. If we ever introduce a
 * role-gated landing page above Tags, switch the target here.
 */

import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/settings/")({
  beforeLoad: () => {
    throw redirect({ to: "/settings/tags" });
  },
});
